export const setElementStyle = (element: HTMLElement, h: string | number = 0) => {
  /**
   * Для текущего компонента очень важно изменять именно max-height,
   * так как это позволяет быть компоненту более эластичным по отношению к контенту,
   * и соответственно принимать размеры в соответствии с этим контентом
   */
  element.style['max-height'] = typeof h === 'number' ? `${h}px` : h;
  element.style['opacity'] = h ? '1' : `0`;
};
